import { render, staticRenderFns } from "./OfferMenuItems.vue?vue&type=template&id=9b3e6386&scoped=true&"
import script from "./OfferMenuItems.vue?vue&type=script&lang=ts&"
export * from "./OfferMenuItems.vue?vue&type=script&lang=ts&"
import style0 from "./OfferMenuItems.vue?vue&type=style&index=0&id=9b3e6386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3e6386",
  null
  
)

export default component.exports